export const MESSAGE_TAB_SYSTEM = 'system';

export const MESSAGE_TAB_USER = 'user';

export const MESSAGE_USER_CODE_TYPE = 'usr';

export const CHAT_MESSAGES_LIMIT_PER_REQUEST = 50;

export const MAX_CUSTOM_TEXT_MESSAGE_LENGTH = 1024;

export const VALIDATE_MESSAGE = {
  validateFileSize: 'File size must be less than 300Kb',
  validateFileType: 'Must be a jpg, jpeg, png, or gif file',
};

export const SCHEDULED_MESSAGE_TYPES = {
  SCHEDULED_MESSAGE: 'SCHEDULED_MESSAGE',
  SCHEDULED_BIRTHDAY_MESSAGE: 'SCHEDULED_BIRTHDAY_MESSAGE',
  EVENT_SMART_ACTION_MESSAGE: 'EVENT_SMART_ACTION_MESSAGE',
  GROUP_SMART_ACTION_MESSAGE: 'GROUP_SMART_ACTION_MESSAGE',
  ORDER_FOLLOW_UP_MESSAGE: 'ORDER_FOLLOW_UP_MESSAGE',
  HOST_INVITE_MESSAGE: 'HOST_INVITE_MESSAGE',
};

export const SCHEDULED_MESSAGE_TYPES_LABELS = {
  SCHEDULED_MESSAGE: 'Manually Scheduled',
  SCHEDULED_BIRTHDAY_MESSAGE: 'Birthday Message',
  EVENT_SMART_ACTION_MESSAGE: 'Event Smart Action',
  GROUP_SMART_ACTION_MESSAGE: 'Group Smart Action',
  ORDER_FOLLOW_UP_MESSAGE: 'Order Follow-Up',
  HOST_INVITE_MESSAGE: 'Host Invite',
};

export const SCHEDULED_MESSAGE_FAILURE_REASON_LABELS = {
  NO_PHONE: 'No Phone Number',
  INVALID_PHONE: 'Invalid Phone Number',
  NOT_TEXTABLE: 'Non-Textable Phone',
  DO_NOT_TEXT: 'Do Not Text',
  GUEST_HOST_FILTER: 'Guest/Host Filter',
  NOT_IN_GROUP: 'Not In Group',
  SMART_FIELD_ERROR: 'Smart Field Error',
  FILTER_EXCLUDED: 'Filter Rule Excluded',
  CREATE_MESSAGE_ERROR: 'Message Creation Error',
  CONTACT_DELETED: 'Contact Deleted',
  // CON-1704 — blocked NANP region
  REGION_NOT_SUPPORTED: 'Outside Texting Area',
  // CON-1481 — subscription gating
  SUBSCRIPTION_CANCELLED: 'Subscription Cancelled',
  METERED_INVOICE_UNPAID: 'Metered Invoice Unpaid',
};

export const SCHEDULED_MESSAGE_FAILURE_FILTER_OPTIONS = [
  { value: 'SENT', label: 'Sent Successfully' },
  { value: 'FAILED', label: 'All Failures' },
  { value: 'NO_PHONE', label: 'No Phone Number' },
  { value: 'INVALID_PHONE', label: 'Invalid Phone Number' },
  { value: 'NOT_TEXTABLE', label: 'Non-Textable Phone' },
  { value: 'DO_NOT_TEXT', label: 'Do Not Text' },
  { value: 'GUEST_HOST_FILTER', label: 'Guest/Host Filter' },
  { value: 'NOT_IN_GROUP', label: 'Not In Group' },
  { value: 'SMART_FIELD_ERROR', label: 'Smart Field Error' },
  { value: 'FILTER_EXCLUDED', label: 'Filter Rule Excluded' },
  { value: 'CREATE_MESSAGE_ERROR', label: 'Message Creation Error' },
  { value: 'CONTACT_DELETED', label: 'Contact Deleted' },
  { value: 'REGION_NOT_SUPPORTED', label: 'Outside Texting Area' },
  // CON-1481 — subscription gating
  { value: 'SUBSCRIPTION_CANCELLED', label: 'Subscription Cancelled' },
  { value: 'METERED_INVOICE_UNPAID', label: 'Metered Invoice Unpaid' },
];

export const FAILURE_REASONS_BY_CONNECTION_TYPE = {
  birthday: [
    'NO_PHONE',
    'INVALID_PHONE',
    'NOT_TEXTABLE',
    'REGION_NOT_SUPPORTED',
    'DO_NOT_TEXT',
    'SMART_FIELD_ERROR',
    'CREATE_MESSAGE_ERROR',
    'CONTACT_DELETED',
  ],
  manually: [
    'NO_PHONE',
    'INVALID_PHONE',
    'NOT_TEXTABLE',
    'REGION_NOT_SUPPORTED',
    'DO_NOT_TEXT',
    'NOT_IN_GROUP',
    'SMART_FIELD_ERROR',
    'FILTER_EXCLUDED',
    'CREATE_MESSAGE_ERROR',
    'CONTACT_DELETED',
  ],
  groupSmartAction: [
    'NO_PHONE',
    'INVALID_PHONE',
    'NOT_TEXTABLE',
    'REGION_NOT_SUPPORTED',
    'DO_NOT_TEXT',
    'NOT_IN_GROUP',
    'SMART_FIELD_ERROR',
    'FILTER_EXCLUDED',
    'CREATE_MESSAGE_ERROR',
    'CONTACT_DELETED',
  ],
  smartAction: [
    'NO_PHONE',
    'INVALID_PHONE',
    'NOT_TEXTABLE',
    'REGION_NOT_SUPPORTED',
    'DO_NOT_TEXT',
    'SMART_FIELD_ERROR',
    'CREATE_MESSAGE_ERROR',
    'CONTACT_DELETED',
  ],
};

export const RATE_LIMIT_REFRESH_SCHEDULED_MESSAGES = 10000;

export const VCARD_FILENAME = 'CP-Contact-Card.vcf';
